module.exports = __webpack_public_path__ + "img/main-jen.2affa727.jpg";